import { render, staticRenderFns } from "./service.vue?vue&type=template&id=6584e6ba&scoped=true"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"
import style0 from "./service.vue?vue&type=style&index=0&id=6584e6ba&prod&lang=less&scoped=true"
import style1 from "./service.vue?vue&type=style&index=1&id=6584e6ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6584e6ba",
  null
  
)

export default component.exports